import type { SignupLinkParams } from '~/utils/unified/signupLink';

import { buildSignupLink, readUtmKeyFromQuery } from '~/utils/unified/signupLink';

/**
 * Builds signup links that carry the campaign the student arrived on. Every public surface offers
 * signup from a page that already holds `?utm_key=` in its own URL, so the key is read off the
 * route rather than passed around — the campaign then survives the public → /login hop.
 */
export const useSignupLink = () => {
  const route = useRoute();

  const buildLink = (params: Omit<SignupLinkParams, 'utmKey'>): string =>
    buildSignupLink({ ...params, utmKey: readUtmKeyFromQuery(route.query) });

  return { buildLink };
};
